import tokenManager from '@/Utils/tokenManager'
import Cookies from 'js-cookie'

export default {
  authSetUser(state, user) {
    state.user = user
    localStorage.setItem('vitale-user', JSON.stringify(user))
  },

  authLogout(state) {
    Cookies.remove('auth-user')

    // Usa o tokenManager para limpar o token de forma segura
    tokenManager.clearToken()

    localStorage.removeItem('auth-domains')
    localStorage.removeItem('origin')
    localStorage.removeItem('current-patient')
    localStorage.removeItem('calendar-item')
    localStorage.removeItem('current-specialist')
    localStorage.removeItem('theme-color')
    localStorage.removeItem('vitale-account')
    localStorage.removeItem('vitale-linked-accounts')
    localStorage.removeItem('vitale-subdomain')
    localStorage.removeItem('vitale-user')

    state.user = null
  }
}
